import {
  Component,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  Input,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { SectoresProductivosService } from "src/app/services/sectores-productivos.service";

import { MatSort } from "@angular/material/sort";
import { CourseResponse } from "src/app/interfaces/response";

@Component({
  selector: "app-renec",
  templateUrl: "./renec.component.html",
  styleUrls: ["./renec.component.css"],
})
export class RenecComponent implements OnInit {
  displayedColumns: string[] = [
    "codigoE",
    "nivelE",
    "tituloE",
    "comiteE",
    "nbSectorE",
  ];
  dataSource: any;
  listadoEm: any;
  marca: boolean;
  esmarca: boolean;

  padre: number;
  titlePadre: string;
  codigoEC: string;
  estandarNB: string;
  cursos: CourseResponse;

  @Output()
  sectorEsById = new EventEmitter<any>();
  @Output()
  backTo = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private service: SectoresProductivosService) {}

  ngOnInit(): void {
    this.getEstandaresMarca();
  }

  async getEstandaresMarca() {
    let get2: any;
    try {
      get2 = await this.service.getEstandaresAll();
      this.listadoEm = get2;

      this.dataSource = new MatTableDataSource<any>(this.listadoEm);
      this.dataSource.filterPredicate = function (
        data,
        filter: string
      ): boolean {
        return (
          data.idSectorProductivo.toString().toLowerCase().includes(filter) ||
          data.codigo.toString().toLowerCase().includes(filter) ||
          data.titulo.toString().toLowerCase().includes(filter) ||
          data.comite.toString().toLowerCase().includes(filter) ||
          data.secProductivo.toString().toLowerCase().includes(filter)
        );
      };
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } catch (error) {
      console.log(error);
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.toLowerCase().trim();
  }

  sectorByID(element) {
    let json = {
      element: element,
      padre: element.codigo,
      titlePadre: element.titulo,
    };
    this.sectorEsById.emit(json);
  }

  home() {
    window.location.reload();
  }

  back() {
    this.backTo.emit(0);
  }
}
